import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import {
  useESGDisclosureSelectionStore,
  useESGReportWorkflowStore,
  useESGReportBuilderStore,
} from "@/features/esg/hooks/useESGReportStore";
import { useTran } from "@/hooks";
import { observer } from "mobx-react-lite";
import DisclosureSelectionCard from "./disclosureSelection/DisclosureSelectionCard";
import CustomDisclosureDialog from "./disclosureSelection/CustomDisclosureDialog";
import DelegateDisclosuresDialog from "./disclosureSelection/DelegateDisclosuresDialog";

const DisclosureSelectionStep = observer(() => {
  const { t } = useTran();
  const { framework } = useESGReportBuilderStore();
  const { setShowCustomDisclosureDialog, setShowDelegateDisclosuresDialog } =
    useESGReportWorkflowStore();
  const {
    selectedCount,
    groupedByCategory,
    isSelectedAllDisclosures,

    selectAll,
    unSelectAll,
  } = useESGDisclosureSelectionStore();

  const isCustomFramework = framework === "CUSTOM";

  return (
    <div className="flex flex-col gap-6 flex-1 min-h-0 overflow-hidden">
      <div className="flex gap-x-2 items-center justify-between">
        <div className="flex gap-x-2 items-center">
          <p className="text-muted-foreground text-sm">
            {t("Pick relevant E/S/G topics for this report")}
          </p>
          <Badge variant="outline">
            {selectedCount} {t("selected")}
          </Badge>
        </div>
        <div className="flex items-center gap-2">
          <Button
            onClick={isSelectedAllDisclosures ? unSelectAll : selectAll}
            size="sm"
          >
            {t(
              isSelectedAllDisclosures
                ? "Unselect All Topics"
                : "Select All Topics",
            )}
          </Button>
          <Button
            variant="secondary"
            onClick={() => setShowDelegateDisclosuresDialog(true)}
            size="sm"
          >
            {t("Delegate Other")}
          </Button>
          {!isCustomFramework && (
            <Button
              variant="outline"
              onClick={() => setShowCustomDisclosureDialog(true)}
              size="sm"
            >
              {t("Add Custom Disclosure")}
            </Button>
          )}
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 flex-1 min-h-0 overflow-hidden">
        {Object.keys(groupedByCategory).map((category, index) => {
          return <DisclosureSelectionCard category={category} key={index} />;
        })}
      </div>
      <CustomDisclosureDialog />
      <DelegateDisclosuresDialog />
    </div>
  );
});

export default DisclosureSelectionStep;
